// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../rescript/lib/es6/curry.js";
import * as Generic$ApiTypes from "./utils/Generic.bs.js";

var currencyOptions_fromJson = Curry._3(Generic$ApiTypes.Decode.map2, Curry._2(Generic$ApiTypes.Decode.field, "suggestedCurrency", Generic$ApiTypes.Decode.string), Curry._2(Generic$ApiTypes.Decode.field, "availableCurrencies", Curry._1(Generic$ApiTypes.Decode.array, Generic$ApiTypes.Decode.string)), (function (suggestedCurrency, availableCurrencies) {
        return {
                suggestedCurrency: suggestedCurrency,
                availableCurrencies: availableCurrencies
              };
      }));

var countryOptions_fromJson = Curry._3(Generic$ApiTypes.Decode.map2, Curry._2(Generic$ApiTypes.Decode.field, "suggestedCountry", Generic$ApiTypes.Decode.string), Curry._2(Generic$ApiTypes.Decode.field, "availableCountries", Curry._1(Generic$ApiTypes.Decode.array, Generic$ApiTypes.Decode.string)), (function (suggestedCountry, availableCountries) {
        return {
                suggestedCountry: suggestedCountry,
                availableCountries: availableCountries
              };
      }));

var choices_fromJson = Curry._2(Generic$ApiTypes.Decode.oneOf, Generic$ApiTypes.Decode.deccoVariantWithPayload("Currencies", currencyOptions_fromJson, (function (c) {
            return {
                    TAG: /* Currencies */1,
                    _0: c
                  };
          })), [
      Generic$ApiTypes.Decode.deccoVariantWithPayload("Countries", countryOptions_fromJson, (function (i) {
              return {
                      TAG: /* Countries */0,
                      _0: i
                    };
            })),
      Generic$ApiTypes.Decode.simpleVariant([[
              "NotSupported",
              /* NotSupported */0
            ]])
    ]);

var fromJson = Curry._2(Generic$ApiTypes.Decode.map, Curry._2(Generic$ApiTypes.Decode.field, "choices", Curry._1(Generic$ApiTypes.Decode.option, choices_fromJson)), (function (choices) {
        return {
                choices: choices
              };
      }));

export {
  currencyOptions_fromJson ,
  countryOptions_fromJson ,
  choices_fromJson ,
  fromJson ,
}
/* currencyOptions_fromJson Not a pure module */
